module.exports = __webpack_public_path__ + "static/media/background-adimas.0fe73bf9.jpg";